import React, { Component } from 'react';
import App_data from '../../config/App_data';
import FD from '../../RestAPI/fetchData';
import StarRatings from 'react-star-ratings';
import cjquery from 'jquery';
import { Tooltip, Col, Row } from 'reactstrap';
import GMATSubscriptionCheck from '../../RestAPI/GMATSubscription';
import PartnerGMATSubscriptionCheck from '../../RestAPI/PartnerSubscription/GMATSubscription';
import language from '../../../assets/languages/language';
// import { getDeviceDetails } from '../../common/deviceDetails';
import { getIpAddress } from '../../../common/getIpAddress';
import AppRoutes from '../../config/AppRoutes';
import ValidateSaveReportIcon from '../../Common/ValidateSaveReportIcon';
import Loader from '../../../common/loader';
import { renderHTMLContent } from '../../../common/function';
/* eslint-disable*/
class GMATBeginchapters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      MessageTitle: `${language.LC().ALERT}`,
      MessageContent: `${language.LC().ERROR}`,
      questions: [],
      reportLoading: false,
      all_questions_state: [],
      token: '',
      idname: '',
      ValidToken: false,
      chapter_id: '',
      offset: 0,
      limit: 1,
      successAlert: false,
      choice_a: 'answer_box',
      choice_b: 'answer_box',
      choice_c: 'answer_box',
      choice_d: 'answer_box',
      choice_e: 'answer_box',
      result_block: 'card hide_block',
      report_block: 'card hide_block',
      clicked: false,
      choice: '',
      result: '',
      text_color: 'card-header',
      records: '',
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      flagCSS: 'fa fa-flag-o mark-action-btn',
      timerstopbtn: 'icon-control-pause pause_btn',
      savedQuestion: false,
      comment: 'card-block',
      flashcard: 'card-block',
      comment_data: '',
      flash_data: [],
      // flash_form : 'col-sm-12 col-md-12 display_block',
      comment_arrow: '',
      flash_card_arrow: '',
      flash_class: 'edit_right_padding',
      count: 0,
      rating: 0,
      rated: false,
      save_text: `${language.LC().SAVE_QUESTION}`,
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      validated: false,
      comment_update: 'hide_block',
      comment_save: 'btn btn-primary active pointer_class margin_bottom_20',
      comment_update_id: '',
      next_block: '',
      previ_block: '',
      question_length: '',
      timer_stop: false,
      timer_tag: `${language.LC().STOP}`,
      display_loader: 'show_block',
      selectedmenu: 'gmat',
      subscriptionstatus: '',
      chapter_name: '',
      isEditable: false,
      all_questions: '',
      category: 'GMAT',
      tags: ['gmat', 'question'],
      title: '',
      description: '',
      forumComment: '',
      cfaUnlimitedPackage: '',
      cfaUnlimitedActiveExam: '',
      tooltips: [
        {
          placement: `${language.LC().COMMENT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().REPORT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().FLASHCARD_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
      ],
      user_city: '',
      user_country: '',
      user_ip: '',
      user_state: '',
      user_continent: '',
      choice_name: '',
    };
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  saveForumComment(e) {
    this.setState({ forumComment: e.target.value });
  }

  //Function to change, time every second
  tick() {
    this.setState({ count: this.state.count + 1 });
  }

  //Function to redirect page to readings page
  _getReadings = () => {
    this.context.router.push({
      pathname: AppRoutes.GMAT_QUESTION_BANK_READING.replace(':id', this.props.params.notesid),
    });
  };

  _getQuestions = () => {
    this.context.router.push({
      pathname: AppRoutes.GMAT_QUESTION_BANK_LIST_QUE.replace(
        ':chapter_no',
        this.props.params.notesid,
      )
        .replace(':id', this.props.params.readingid)
        .replace(':subscriptionstatus', this.state.subscriptionstatus)
        .replace(':reading', this.state.questions.name),
    });
  };

  //Function to toggle Comment box
  _getToggleComment = (item, e) => {
    cjquery(this.refs['comment_toggle_div']).slideToggle(1000);
  };

  //Function to toggle Flash box
  _getToggleFlash = (item, e) => {
    cjquery(this.refs['flash_toggle_div']).slideToggle(1000);
  };

  //Function to fetch previous question
  _getPrevious = () => {
    this.setState({
      display_loader: 'show_block',
      validated: false,
      rated: false,
      rating: 0,
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      save_text: `${language.LC().SAVE_QUESTION}`,
      timerstopbtn: 'pause_btn icon-control-pause',
      report_block: 'card hide_block',
      choice_name: '',
      bookmarkColor: '',
    });
    this.setState({ clicked: false });
    document.getElementById('comment').value = '';
    const i = this.state.offset - 1;
    this.setState({ offset: i });
    if (i < parseInt(this.state.question_length) - 1) {
      this.setState({ next_block: '' });
    }
    if (i === 0) {
      this.setState({ previ_block: 'card hide_block' });
    }
    const { questions } = this.state;
    this.setState({ questions: this.state.all_questions_state[i] });
    if (questions.right_choice == 'choice_a') {
      this.setState({ choice_name: 'A' });
    } else if (questions.right_choice == 'choice_b') {
      this.setState({ choice_name: 'B' });
    } else if (questions.right_choice == 'choice_c') {
      this.setState({ choice_name: 'C' });
    } else if (questions.right_choice == 'choice_d') {
      this.setState({ choice_name: 'D' });
    } else if (questions.right_choice == 'choice_e') {
      this.setState({ choice_name: 'E' });
    }
    var next_question_id = this.state.all_questions_state[i].id;
    this.context.router.push({
      pathname: AppRoutes.GMAT_QUESTION_BANK_VIEW_QUE.replace(':notesid', this.props.params.notesid)
        .replace(':readingid', this.props.params.readingid)
        .replace(':id', next_question_id)
        .replace(':offset', i),

      // '/beginchapter/' +
      // this.props.params.notesid +
      // '/' +
      // this.props.params.readingid +
      // '/' +
      // next_question_id +
      // '/' +
      // i,
    });
  };

  //Function to fetch Next question
  _getNext = () => {
    this.setState({
      display_loader: 'show_block',
      validated: false,
      rated: false,
      rating: 0,
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      save_text: `${language.LC().SAVE_QUESTION}`,
      timerstopbtn: 'pause_btn icon-control-pause',
      report_block: 'card hide_block',
      choice_name: '',
      bookmarkColor: '',
    });
    this.setState({ clicked: false });
    document.getElementById('comment').value = '';
    const i = this.state.offset + 1;
    // alert(i);
    //console.log(this.props.params.readingid);
    this.setState({ offset: i });
    this.setState({ questions: this.state.all_questions_state[i] });

    if (parseInt(this.state.question_length) - 1 === i) {
      this.setState({ next_block: 'card hide_block' });
    }

    if (i != 0) {
      this.setState({ previ_block: '' });
    }
    const { questions } = this.state;
    this.setState({ questions: this.state.all_questions_state[i] });
    if (questions.right_choice == 'choice_a') {
      this.setState({ choice_name: 'A' });
    } else if (questions.right_choice == 'choice_b') {
      this.setState({ choice_name: 'B' });
    } else if (questions.right_choice == 'choice_c') {
      this.setState({ choice_name: 'C' });
    } else if (questions.right_choice == 'choice_d') {
      this.setState({ choice_name: 'D' });
    } else if (questions.right_choice == 'choice_e') {
      this.setState({ choice_name: 'E' });
    }
    var next_question_id = this.state.all_questions_state[i].id;
    // console.log(this.state.token)
    // console.log(this.state.idname)
    this.context.router.push({
      pathname: AppRoutes.GMAT_QUESTION_BANK_VIEW_QUE.replace(':notesid', this.props.params.notesid)
        .replace(':readingid', this.props.params.readingid)
        .replace(':id', next_question_id)
        .replace(':offset', i),

      // '/beginchapter/' +
      // this.props.params.notesid +
      // '/' +
      // this.props.params.readingid +
      // '/' +
      // next_question_id +
      // '/' +
      // i,
    });
  };

  //Function to check Right Or Wrong Answered and displayed clicked box
  _getAnswer = (choice, e) => {
    this.setState({ clicked: true });
    this.setState({ choice: choice });
    // const result = getDeviceDetails();

    if (choice === 'choice_a') {
      this.setState({ choice_a: 'answer_box clicked_box' });
      this.setState({ choice_b: 'answer_box' });
      this.setState({ choice_c: 'answer_box' });
      this.setState({ choice_d: 'answer_box' });
      this.setState({ choice_e: 'answer_box' });
    } else if (choice === 'choice_b') {
      this.setState({ choice_b: 'answer_box clicked_box' });
      this.setState({ choice_a: 'answer_box' });
      this.setState({ choice_c: 'answer_box' });
      this.setState({ choice_d: 'answer_box' });
      this.setState({ choice_e: 'answer_box' });
    } else if (choice === 'choice_c') {
      this.setState({ choice_c: 'answer_box clicked_box' });
      this.setState({ choice_a: 'answer_box' });
      this.setState({ choice_b: 'answer_box' });
      this.setState({ choice_d: 'answer_box' });
      this.setState({ choice_e: 'answer_box' });
    } else if (choice === 'choice_d') {
      this.setState({ choice_d: 'answer_box clicked_box' });
      this.setState({ choice_a: 'answer_box' });
      this.setState({ choice_b: 'answer_box ' });
      this.setState({ choice_c: 'answer_box' });
      this.setState({ choice_e: 'answer_box' });
    } else if (choice === 'choice_e') {
      this.setState({ choice_e: 'answer_box clicked_box' });
      this.setState({ choice_a: 'answer_box' });
      this.setState({ choice_b: 'answer_box' });
      this.setState({ choice_c: 'answer_box' });
      this.setState({ choice_d: 'answer_box' });
    }
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      id: this.props.params.id,
      city: this.state.user_city,
      country: this.state.user_country,
      state: this.state.user_state,
      continent: this.state.user_continent,
      ip: this.state.user_ip,
    };
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/trackUserRecord', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
      }
    });
  };

  //Function to show Report box
  _displayReportForm = (item, e) => {
    this.setState({ report_block: 'card show_block' });
  };

  //Function to hide Report box
  _hideReportForm = (item, e) => {
    this.setState({ report_block: 'card hide_block' });
  };

  //Function to show Correct box and display right answer and store in database
  _getResult = async (item, e) => {
    if (this.state.clicked) {
      clearInterval(this.timer);
      const chosen_answer = this.state.choice;
      var right_answer = 0;
      this.setState({ result_block: 'card show_block' });
      if (item.right_choice === this.state.choice) {
        right_answer = 1;
        if (this.state.choice === 'choice_a') {
          this.setState({ choice_a: 'answer_box success', choice_name: 'A' });
        } else if (this.state.choice === 'choice_b') {
          this.setState({ choice_b: 'answer_box success', choice_name: 'B' });
        } else if (this.state.choice === 'choice_c') {
          this.setState({ choice_c: 'answer_box success', choice_name: 'C' });
        } else if (this.state.choice === 'choice_d') {
          this.setState({ choice_d: 'answer_box success', choice_name: 'D' });
        } else if (this.state.choice === 'choice_e') {
          this.setState({ choice_e: 'answer_box success', choice_name: 'E' });
        }

        this.setState({
          result: `${language.LC().CORRECT}`,
          text_color: 'card-header text_success',
          result_block: 'card show_block',
        });
      } else {
        right_answer = 0;
        if (this.state.choice === 'choice_a') {
          this.setState({ choice_a: 'answer_box failure' });
        } else if (this.state.choice === 'choice_b') {
          this.setState({ choice_b: 'answer_box failure' });
        } else if (this.state.choice === 'choice_c') {
          this.setState({ choice_c: 'answer_box failure' });
        } else if (this.state.choice === 'choice_d') {
          this.setState({ choice_d: 'answer_box failure' });
        } else if (this.state.choice === 'choice_e') {
          this.setState({ choice_e: 'answer_box failure' });
        }
        if (item.right_choice === 'choice_a') {
          this.setState({ choice_a: 'answer_box success', choice_name: 'A' });
        } else if (item.right_choice === 'choice_b') {
          this.setState({ choice_b: 'answer_box success', choice_name: 'B' });
        } else if (item.right_choice === 'choice_c') {
          this.setState({ choice_c: 'answer_box success', choice_name: 'C' });
        } else if (item.right_choice === 'choice_d') {
          this.setState({ choice_d: 'answer_box success', choice_name: 'D' });
        } else if (item.right_choice === 'choice_e') {
          this.setState({ choice_e: 'answer_box success', choice_name: 'E' });
        }
        this.setState({
          text_color: 'card-header text_failure',
          result: `${language.LC().INCORRECT}`,
          result_block: 'card show_block',
        });
      }
      if (!this.state.validated) {
        var data = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: item.id,
          right_answer: right_answer,
          time_done: this.state.count,
        };

        await FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveStats', data).then(
          async resp => {
            if (resp.success) {
              this.setState({ ValidToken: true, validated: true });
            } else {
              this.setState({ ValidToken: false });
            }
            return resp;
          },
        );
      }
    }
  };

  //Function to Display Saved Question on button and save in database
  _saveQuestion = (item, e) => {
    console.log('item ----------->', item);
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      topic_name: item.name,
      reading_id: item.reading_id,
    };
    if (this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
      // return;
      FD.callAPI(App_data.backend_api + '/gmat_question_bank/unsaveQuestion', data).then(resp => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
            bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
            bookmarkColor: '',
            save_text: `${language.LC().SAVE_QUESTION}`,
          });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      });
    } else {
      FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveQuestion', data).then(resp => {
        if (resp.success) {
          this.setState({ ValidToken: true });
          this.setState({
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
          });
          this.setState({
            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
          });
          this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
          this.setState({ save_text: `${language.LC().Question_Saved}` });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      });
    }
  };

  //Function to Save flash Card And display new stored flash card
  _saveFlashCard = (item, e) => {
    if (document.getElementById('flash_card').value == '') {
      return;
    }

    var flash_card = document.getElementById('flash_card').value;
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      flash_card: flash_card,
    };
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveFlashCard', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        document.getElementById('flash_card').value = '';
        var params = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: item.id,
        };
        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFlashCards', params).then(
          response => {
            if (response.success) {
              this.setState({ ValidToken: true });
              if (response.flash_cards.length > 0) {
                this.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
                var flash_cards = response.flash_cards.map((items, index) => (
                  //alert(items.id)
                  <li key={index}>
                    <div className=''>
                      <ul className='icon_list'>
                        <li>
                          <a className='pointer_class' onClick={this._editFlash.bind(this, items)}>
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteFlash.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                      <div className={this.state.flash_class}>
                        <h4 />
                        <p>{items.flash_card}</p>
                      </div>
                    </div>
                  </li>
                ));
              } else {
                this.setState({
                  flash_form: 'col-sm-12 col-md-12 display_block',
                });
                var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              }
              this.setState({ flash_data: flash_cards });
            } else {
              var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              this.setState({ ValidToken: false });
              this.setState({ flash_data: flash_cards });
              this.setState({ flash_form: 'col-sm-12 col-md-12 display_block' });
            }
            return response;
          },
        );
      } else {
        this.setState({ ValidToken: false });
      }
    });
  };

  //Funcion to save new report question
  _reportQuestion = (item, e) => {
    var comment = document.getElementById('comment').value;
    if (comment.length < 2) {
      return;
    }
    // const result = getDeviceDetails();
    console.log('item ------------> ', item);
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      comment: comment,
      city: this.state.user_city,
      country: this.state.user_country,
      state: this.state.user_state,
      continent: this.state.user_continent,
      ip: this.state.user_ip,
      topic_name: item.name,
      reading_id: item.reading_id,
    };
    // console.log(data);
    this.setState({
      reportLoading: true,
    });
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/reportQuestion', data).then(resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          successAlert: true,
          reportLoading: false,
        });
        document.getElementById('comment').value = '';
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  };

  onClose = e => {
    this.setState({
      report_block: 'card hide_block',
      successAlert: false,
    });
  };

  //Function to Edit Flash card
  _editFlash = (item, e) => {
    this.setState({
      flash_form: 'col-sm-12 col-md-12 display_block',
      isEditable: true,
    });

    document.getElementById('flash_card').value = item.flash_card;
  };

  //Function to delete flash card
  _deleteFlash = (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      flash_card: item,
    };
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/deleteFlashCard', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        this.setState({
          flash_form: 'col-sm-12 col-md-12 display_block',
          isEditable: false,
        });
        document.getElementById('flash_card').value = '';
        var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
        this.setState({ flash_data: flash_cards });
      } else {
        this.setState({ ValidToken: false });
      }
    });
  };

  //Function to give star rattings
  onStarClick(item, nextValue, prevValue, name) {
    if (prevValue !== nextValue);
    {
      var params = {
        token: this.state.token,
        idname: this.state.idname,
        question_id: item.id,
        ratting: nextValue,
      };
      FD.callAPI(App_data.backend_api + '/gmat_question_bank/UpdateGMATRatting', params).then(
        response => {
          if (response.success) {
            this.setState({ rated: 1 });
            this.setState({ ratting_text: 'Rated ' });
          }
        },
      );
    }
    this.setState({ rating: nextValue });
    var params = {
      token: this.state.token,
      question_id: item.id,
      idname: this.state.idname,
    };
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/getGMATRatting', params).then(
      response => {
        if (response.success) {
          if (response.ratting.length > 0) {
            this.setState({ rated: true });
            response.ratting.map(items => {
              this.setState({ rating: items.ratting });
              this.setState({ ratting_text: `${language.LC().RATED}` });
            });
          } else {
            var params = {
              token: this.state.token,
              idname: this.state.idname,
              question_id: item.id,
              ratting: nextValue,
            };
            FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(
              response => {
                if (response.success) {
                  this.setState({ rated: 1 });
                  this.setState({ ratting_text: `${language.LC().RATED}` });
                }
              },
            );
          }
        } else {
          var params = {
            token: this.state.token,
            idname: this.state.idname,
            question_id: item.id,
            ratting: nextValue,
          };
          FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(
            response => {
              if (response.success) {
                this.setState({ rated: 1 });
                this.setState({
                  ratting_text: `${language.LC().RATED}` + nextValue + ' ' + 'stars',
                });
              }
            },
          );
        }
      },
    );
  }

  _getSubscribe = () => {
    this.context.router.push({
      pathname: '/subscribe/',
      state: { token: this.state.token, idname: this.state.idname },
    });
  };

  async componentDidMount() {
    window.scrollTo(0, 0);
    // api to get ip address
    const result = await getIpAddress();
    if (result) {
      this.setState({
        user_city: result.city,
        user_country: result.country,
        user_ip: result.query,
        user_state: result.region,
        user_continent: result.continent,
      });
    }

    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState({
        idname: storage_session['idname'],
        token: storage_session['token'],
      });
    }
    var user_data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
    };
    FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(async resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this._runCode('free');
          this.setState({ subscriptionstatus: 'free' });
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;

          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = await PartnerGMATSubscriptionCheck.checkGMATQuestionSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                if (isInArray_var) {
                  this._runCode('paid');
                  this.setState({ subscriptionstatus: 'paid' });
                } else {
                  this._runCode('free');
                  this.setState({ subscriptionstatus: 'free' });
                }
              } else {
                console.log('fail');
              }
            },
          );
        }
      } else {
        if (
          resp.profileInfo.exam_selected === '' &&
          resp.profileInfo.cfaUnlimitedPackage === '' &&
          resp.profileInfo.cfaUnlimitedActiveExam === ''
        ) {
          this._runCode('free');
          this.setState({ subscriptionstatus: 'free' });
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = GMATSubscriptionCheck.checkGMATQuestionSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                if (isInArray_var) {
                  this._runCode('paid');
                  this.setState({ subscriptionstatus: 'paid' });
                } else {
                  this._runCode('free');
                  this.setState({ subscriptionstatus: 'free' });
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      }
    });
  }

  async _runCode(subscriptionstatus) {
    // console.log("subscriptionstatus")
    // console.log(subscriptionstatus)
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      reading_id: this.props.params.readingid,
      chapter_id: this.props.params.notesid,
      offset: this.state.offset,
      subscriptionstatus: subscriptionstatus,
    };
    // console.log('data------------------------', data);
    /*Api to call all question by chapter ,reading wise without limit and offset*/
    await FD.callAPI(App_data.backend_api + '/gmat_question_bank/getQuestions_allcr', data).then(
      async resp => {
        // console.log(
        //   'resp------------------------------>----------------------------------------------------------------------',
        //   resp
        // );
        if (resp.success) {
          this.setState({ ValidToken: true });
          this.setState({ all_questions_state: resp.questions });
          let ques_res = [];
          let offset_res = '';
          for (var i = 0; i < resp.questions.length; i++) {
            if (resp.questions[i].id == this.props.params.id) {
              ques_res = resp.questions[i];
              offset_res = i;
            }
            if (i == resp.questions.length - 1) {
              this.setState({ display_loader: 'hide_block' });
            }
          }
          this.setState({ questions: ques_res }, () => {
            if (ques_res.right_choice == 'choice_a') {
              this.setState({ choice_name: 'A' });
            } else if (ques_res.right_choice == 'choice_b') {
              this.setState({ choice_name: 'B' });
            } else if (ques_res.right_choice == 'choice_c') {
              this.setState({ choice_name: 'C' });
            } else if (ques_res.right_choice == 'choice_d') {
              this.setState({ choice_name: 'D' });
            } else if (ques_res.right_choice == 'choice_e') {
              this.setState({ choice_name: 'E' });
            }
          });

          await this.setState({
            offset: offset_res,
            question_length: resp.questions.length,
          });

          var retun_all_question = JSON.stringify(this.state.questions);
          var all_questions = JSON.parse(retun_all_question);
          await this.setState({ all_questions: all_questions });

          if (offset_res == 0) {
            this.setState({ previ_block: 'card hide_block' });
          }

          if (offset_res == parseInt(resp.questions.length) - 1) {
            this.setState({ next_block: 'card hide_block' });
          }

          var params = {
            token: this.state.token,
            question_id: ques_res.id,
            idname: this.state.idname,
          };
          //Api to Fetch saved question stats
          FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFavQuestions', params).then(
            response => {
              if (response.success) {
                this.setState({
                  save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
                });
                this.setState({
                  bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
                });
                this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
                this.setState({ save_text: `${language.LC().Question_Saved}` });
              }
            },
          );
          var params = {
            token: this.state.token,
            question_id: ques_res.id,
            idname: this.state.idname,
          };
          //Api to get ratting
          FD.callAPI(App_data.backend_api + '/gmat_question_bank/getGMATRatting', params).then(
            response => {
              if (response.success) {
                this.setState({ rated: true });
                response.ratting.map(items => {
                  this.setState({ rating: items.ratting });
                  this.setState({ ratting_text: `${language.LC().RATED}` });
                });
              }
            },
          );
          var params = {
            token: this.state.token,
            idname: this.state.idname,
            question_id: ques_res.id,
          };
          //Api to fetch flashcard by question id
          FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFlashCards', params).then(
            response => {
              if (response.success) {
                this.setState({ ValidToken: true });
                if (response.flash_cards.length > 0) {
                  this.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
                  var flash_cards = response.flash_cards.map((items, index) => (
                    //alert(items.id)
                    <li key={index}>
                      <div className=''>
                        <ul className='icon_list'>
                          <li>
                            <a
                              className='pointer_class'
                              onClick={this._editFlash.bind(this, items)}
                            >
                              <i className='fa fa-pencil' />
                            </a>
                          </li>
                          <li>
                            <a
                              className='pointer_class'
                              onClick={this._deleteFlash.bind(this, items)}
                            >
                              <i className='fa fa-close' />
                            </a>
                          </li>
                        </ul>
                        <div className={this.state.flash_class}>
                          <h4 />
                          <p>{items.flash_card}</p>
                        </div>
                      </div>
                    </li>
                  ));
                } else {
                  this.setState({
                    flash_form: 'col-sm-12 col-md-12 display_block',
                  });
                  var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
                }
                this.setState({ flash_data: flash_cards });
              } else {
                var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
                this.setState({ ValidToken: false });
                this.setState({ flash_data: flash_cards });
                this.setState({ flash_form: 'col-sm-12 col-md-12 display_block' });
              }
              return response;
            },
          );

          this.setState({ records: '' });
        } else {
          this.setState({ ValidToken: false });
          this.setState({ records: `${language.LC().Result_not_found}` });
        }
        clearInterval(this.timer);
        this.timer = setInterval(this.tick.bind(this), 1000);
        return resp;
      },
    );

    FD.callAPI(App_data.backend_api + '/gmat_question_bank/getChapterbyID', data).then(resp => {
      if (resp.success) {
        this.setState({ chapter_name: resp.chapters[0].chapter_name });
      } else {
        // console.log('Chapter Name Not Found');
      }
    });
  }

  /*on url change run this function*/
  componentWillReceiveProps(nextProps) {
    //console.log(this.props);
    // var subscription=this.state.subscriptionstatus;
    if (nextProps.params.id != this.props.params.id) {
      this._changeContent(
        nextProps.params.id,
        nextProps.params.notesid,
        nextProps.params.readingid,
        this.state.token,
        this.state.idname,
        nextProps.params.offset,
      );
      this.setState({ display_loader: 'show_block' });
    }
  }

  /*on url change run this function*/

  _changeContent(qui_id, chapter_id, readingid, token_id, idname, offset_val, subscription) {
    var data = {
      token: token_id,
      idname: idname,
      reading_id: readingid,
      chapter_id: chapter_id,
      offset: offset_val,
      subscriptionstatus: this.state.subscriptionstatus,
    };
    // console.log("subscriptionstatus")
    // console.log(this.state.subscriptionstatus)
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/getQuestions_allcr', data).then(resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          choice_a: 'answer_box',
          choice_b: 'answer_box',
          choice_c: 'answer_box',
          choice_d: 'answer_box',
          choice_e: 'answer_box',
          result_block: 'card hide_block',
        });
        let ques_res = [];
        for (var i = 0; i < resp.questions.length; i++) {
          if (resp.questions[i].id == this.props.params.id) {
            ques_res = resp.questions[i];
          }
        }
        const { questions } = this.state;

        this.setState({ questions: ques_res }, () => {
          if (questions.right_choice == 'choice_a') {
            this.setState({ choice_name: 'A' });
          } else if (questions.right_choice == 'choice_b') {
            this.setState({ choice_name: 'B' });
          } else if (questions.right_choice == 'choice_c') {
            this.setState({ choice_name: 'C' });
          } else if (questions.right_choice == 'choice_d') {
            this.setState({ choice_name: 'D' });
          } else if (questions.right_choice == 'choice_e') {
            this.setState({ choice_name: 'E' });
          }
        });
        this.setState({ display_loader: 'hide_block' });
        var params = {
          token: this.state.token,
          question_id: ques_res.id,
          idname: this.state.idname,
        };
        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFavQuestions', params).then(
          response => {
            // console.log(response);
            // console.log("getFavQuestions");
            if (response.success) {
              this.setState({
                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
              });
              this.setState({
                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
              });
              this.setState({ save_text: `${language.LC().Question_Saved}` });
              this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
            }
          },
        );
        var params = {
          token: this.state.token,
          question_id: ques_res.id,
          idname: this.state.idname,
        };
        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getGMATRatting', params).then(
          response => {
            if (response.success) {
              this.setState({ rated: true });
              response.ratting.map(items => {
                this.setState({ rating: items.ratting });
                this.setState({ ratting_text: `${language.LC().RATED}` });
              });
            }
          },
        );
        var params = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: ques_res.id,
        };
        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFlashCards', params).then(
          response => {
            if (response.success) {
              this.setState({ ValidToken: true });

              if (response.flash_cards.length > 0) {
                this.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
                var flash_cards = response.flash_cards.map((items, index) => (
                  //alert(items.id)
                  <li key={index}>
                    <div className=''>
                      <ul className='icon_list'>
                        <li>
                          <a className='pointer_class' onClick={this._editFlash.bind(this, items)}>
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteFlash.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                      <div className={this.state.flash_class}>
                        <h4 />
                        <p>{items.flash_card}</p>
                      </div>
                    </div>
                  </li>
                ));
              } else {
                this.setState({
                  flash_form: 'col-sm-12 col-md-12 display_block',
                });
                var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              }
              this.setState({ flash_data: flash_cards });
            } else {
              var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              this.setState({ ValidToken: false });
              this.setState({ flash_data: flash_cards });
              this.setState({ flash_form: 'col-sm-12 col-md-12 display_block' });
            }
            return response;
          },
        );
        this.setState({ records: '' });
      } else {
        this.setState({ ValidToken: false });
        this.setState({ records: `${language.LC().Result_not_found}` });
      }
      clearInterval(this.timer);
      this.timer = setInterval(this.tick.bind(this), 1000);
      return resp;
    });
    this.setState({ timer_stop: false });
    this.setState({ timer_tag: `${language.LC().STOP}` });
    this.setState({ count: 0 });
    clearInterval(this.timer);
    this.timer = setInterval(this.tick.bind(this), 1000);
  }

  /*Function to start or stop timer*/
  _timer_funct = (item, e) => {
    if (this.state.timer_stop) {
      this.setState({ timer_stop: false });
      this.setState({ timer_tag: `${language.LC().STOP}` });
      clearInterval(this.timer);
      this.setState({ timerstopbtn: 'pause_btn icon-control-pause' });
      this.timer = setInterval(this.tick.bind(this), 1000);
    } else {
      this.setState({ timer_stop: true });
      this.setState({ timer_tag: `${language.LC().START}` });
      this.setState({ timerstopbtn: 'pause_btn icon-control-play' });
      clearInterval(this.timer);
    }
  };

  _displayOuterElement = () => {
    // console.log("working");
    var d = document.getElementById('d');
    // console.log("dsacds");
    // console.log(d.outerHTML);
  };

  render() {
    // console.log(
    //   'this.state.choice_namethis.state.choice_name',
    //   this.state.choice_name
    // );
    let questions = this.state.questions;
    const { rating, reportLoading } = this.state;
    let forumData = '';
    let data = '';
    const choice_a = 'choice_a';
    const choice_b = 'choice_b';
    const choice_c = 'choice_c';
    const choice_d = 'choice_d';
    const choice_e = 'choice_e';

    let count_temp_var = this.state.count;
    let display_time = '';
    if (count_temp_var < 60) {
      display_time = count_temp_var + 'sec';
    } else {
      var temp_min = Math.trunc(count_temp_var / 60);
      var temp_sec = Math.trunc(count_temp_var % 60);
      display_time = temp_min + 'min ' + temp_sec + 'sec';
    }

    var retun_all_question = JSON.stringify(this.state.questions);
    var all_questions = JSON.parse(retun_all_question);

    if (all_questions != '') {
      forumData = `<div class="col-sm-12 no-cursor" >
            <div class="margin_bottom_40">
                <div >
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="row no-cursor">
                                <div class="col-sm-12 cursor-text">
                                    <div contentEditable='false' class="margin_bottom_40 view_questionhtml bg_blue "> ${all_questions.question
        } </div>
                                </div>
                                <div class="col-sm-12 no-cursor" id="choice_a" >
                                    <div class="answer_box_forum">
                                        <div class="answer_count">
                                        ${language.LC().A}
                                        </div>
                                        <p class="ans_box_text"> 
                                        <span contentEditable='false'> ${all_questions.choice_a
        } </span></p>
                                    </div>
                                </div>

                                <div class="col-sm-12 no-cursor" id="choice_b">
                                    <div class="answer_box_forum">
                                        <div class="answer_count">
                                        ${language.LC().B}
                                        </div>
                                        <p class="ans_box_text"><span contentEditable='false'>  ${all_questions.choice_b
        } </span></p>
                                    </div>
                                </div>
                                
                                <div class="col-sm-12 no-cursor" id="choice_c" >
                                    <div class="answer_box_forum">
                                        <div class="answer_count">
                                        ${language.LC().C}
                                        </div>
                                        <p class="ans_box_text"><span contentEditable='false'>
                                        ${all_questions.choice_c}
                                        </span></p>
                                    </div>
                                    </div>

                                    <div class="col-sm-12 no-cursor" id="choice_d" >
                                    <div class="answer_box_forum">
                                        <div class="answer_count">
                                        ${language.LC().D}
                                        </div>
                                        <p class="ans_box_text"> 
                                        <span contentEditable='false'> ${all_questions.choice_d
        } </span></p>
                                    </div>
                                </div>

                                <div class="col-sm-12 no-cursor margin_bottom_30" id="choice_e" >
                                    <div class="answer_box_forum">
                                        <div class="answer_count">
                                        ${language.LC().E}
                                        </div>
                                        <p class="ans_box_text"> 
                                        <span contentEditable='false'> ${all_questions.choice_e
        } </span></p>
                                    </div>
                                </div>

                                <div class="col-sm-12 cursor-text">
                                <p contentEditable='false' class='view_questionhtml'> 
                                  ${language.LC().THE_CORRECT_ANSWER_IS} ${this.state.choice_name
        }).</p>
                                <p contentEditable='false' class='view_questionhtml'> ${all_questions.answer
        }</p>
                                </div>
                                <div class="col-sm-12 margin_bottom_30 no-cursor">

                                <div class="userQuestionDiv">
                                <span class="questionColor cursor-text"> *User Question: </span>
                                <div class="forum-data-comment cursor-text">
                                  <h4> ${this.state.forumComment} 
                                  </h4>
                                </div>
                                </div>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`;

      data = (
        <div className='col-sm-12'>
          <div className='card margin_bottom_40'>
            <div className='card-header'>
              <img
                src={App_data.frontend_url + '/img/question_bank/question_icon_blue.svg'}
                className='margin_right_20'
                width='30'
                alt=''
              />
              {renderHTMLContent(all_questions.name, "span", "", { contentEditable: 'false' })}
              {' '}
              ({language.LC().Q} {all_questions.id})
              <div className='float-right text-right'>
                <i
                  className={'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block}
                  onClick={this._getPrevious}
                />
                <i
                  className={'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block}
                  onClick={this._getNext}
                />
              </div>
            </div>

            <div className='card-block'>
              <div className='row'>
                <div className='col-sm-9'>
                  <div className='row'>
                    <div className='col-sm-12'>
                      {renderHTMLContent(
                        all_questions.question,
                        "div",
                        "margin_bottom_40 view_questionhtml bg_blue",
                        { contentEditable: 'false' }
                      )}
                    </div>

                    <div
                      className='col-sm-12'
                      id='choice_a'
                      onClick={this._getAnswer.bind(this, choice_a)}
                    >
                      <div className={this.state.choice_a}>
                        <div className='answer_count'>{language.LC().A}</div>
                        <p className='ans_box_text'>
                          {' '}
                          {renderHTMLContent(all_questions.choice_a, "span", "", { contentEditable: 'false' })}
                        </p>
                      </div>
                    </div>

                    <div
                      className='col-sm-12'
                      id='choice_b'
                      onClick={this._getAnswer.bind(this, choice_b)}
                    >
                      <div className={this.state.choice_b}>
                        <div className='answer_count'>{language.LC().B}</div>
                        <p className='ans_box_text'>
                          {renderHTMLContent(all_questions.choice_b, "span", "", { contentEditable: 'false' })}
                        </p>
                      </div>
                    </div>

                    <div
                      className='col-sm-12'
                      id='choice_c'
                      onClick={this._getAnswer.bind(this, choice_c)}
                    >
                      <div className={this.state.choice_c}>
                        <div className='answer_count'>{language.LC().C}</div>
                        <p className='ans_box_text'>
                          {renderHTMLContent(all_questions.choice_c, "span", "", { contentEditable: 'false' })}
                        </p>
                      </div>
                    </div>

                    <div
                      className='col-sm-12'
                      id='choice_d'
                      onClick={this._getAnswer.bind(this, choice_d)}
                    >
                      <div className={this.state.choice_d}>
                        <div className='answer_count'>{language.LC().D}</div>
                        <p className='ans_box_text'>
                          {renderHTMLContent(all_questions.choice_d, "span", "", { contentEditable: 'false' })}
                        </p>
                      </div>
                    </div>

                    <div
                      className='col-sm-12'
                      id='choice_e'
                      onClick={this._getAnswer.bind(this, choice_e)}
                    >
                      <div className={this.state.choice_e}>
                        <div className='answer_count'>{language.LC().E}</div>
                        <p className='ans_box_text'>
                          {renderHTMLContent(all_questions.choice_e, "span", "", { contentEditable: 'false' })}
                        </p>
                      </div>
                    </div>

                    <Col md={12} className='mt-2'>
                      <Row className='align-items-center'>
                        <ValidateSaveReportIcon
                          isQue={true}
                          _getResult={this._getResult}
                          _saveQuestion={this._saveQuestion}
                          _displayReportForm={this._displayReportForm}
                          all_questions={all_questions}
                          save_text={this.state.save_text}
                          bookmarkCSS={this.state.bookmarkCSS}
                          bookmarkColor={this.state.bookmarkColor}
                        />
                        <div className='col-lg-6 col-md-12 mt-md-1 mt-lg-0 text-lg-right'>
                          <div className='star_rating_wrap'>
                            <span className=' margin_bottom_0 margin_right_10'>
                              {this.state.ratting_text}
                            </span>
                            <StarRatings
                              rating={this.state.rating}
                              starRatedColor='rgb(255, 180, 0)'
                              starEmptyColor='rgb(51, 51, 51)'
                              starDimension='20px'
                              starHoverColor='rgb(255, 180, 0)'
                              starSpacing='2px'
                              changeRating={this.onStarClick.bind(this, all_questions)}
                              numberOfStars={5}
                              name='rate1'
                            />
                            {/* <StarRatingComponent
                            name="rate1"
                            starCount={5}
                            value={rating}
                            onStarClick={this.onStarClick.bind(
                              this,
                              all_questions
                            )}
                          /> */}
                          </div>
                        </div>
                      </Row>
                    </Col>
                  </div>
                </div>

                <div className='col-sm-3'>
                  <div className='timer_outer'>
                    <i className='fa fa-clock-o' />
                    <span className='timer_box'>{display_time}</span>
                  </div>

                  <button
                    type='button'
                    className={this.state.timerstopbtn}
                    onClick={this._timer_funct.bind(this, questions)}
                  >
                    {/*this.state.timer_tag*/}
                  </button>
                  {this.state.subscriptionstatus == 'free' ? (
                    <a
                      onClick={this._getSubscribe}
                      className='box_question_color text-center cursor_pointer'
                    >
                      <p className='margin_bottom_0'>
                        {' '}
                        {language.LC().SUBSCRIBE_FOR_1000_PRACTICE_QUESTIONS}{' '}
                      </p>
                    </a>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className={`${this.state.result_block} font-lusitana font-16px`}>
            <div className={this.state.text_color}>{this.state.result}</div>
            <div className='card-block'>
              <p>
                {language.LC().THE_CORRECT_ANSWER_IS} <strong>{this.state.choice_name}.</strong>
              </p>
              {renderHTMLContent(
                all_questions.answer,
                "p",
                "view_questionhtml",
                { contentEditable: 'false' }
              )}
            </div>
          </div>

          <div className={this.state.report_block}>
            <div className='card-header'>
              {language.LC().REPORT}
              {/* <TooltipItem
                key="1"
                id="1"
                content={this.state.tooltips[1].placement}
                place_tip={this.state.tooltips[1].text_align}
              /> */}
            </div>

            {!this.state.successAlert ? (
              <div className='card-block'>
                <div className='row'>
                  <div className='col-sm-12'>
                    <label className='form-control-label' htmlFor='textarea-input'>
                      <strong> {language.LC().COMMENT}</strong>
                    </label>
                  </div>
                  <div className='col-sm-12 margin_bottom_10'>
                    <textarea
                      id='comment'
                      name='comment'
                      rows='6'
                      className='form-control'
                      placeholder='Content..'
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-sm-12'>
                    <button
                      type='button'
                      className='btn btn-primary active pointer_class report-btn'
                      disabled={reportLoading}
                      onClick={this._reportQuestion.bind(this, all_questions)}
                    >
                      {' '}
                      {reportLoading ? language.LC().PLEASE_WAIT : language.LC().REPORT}
                    </button>
                    <button
                      type='button'
                      className='btn btn-danger active pointer_class margin_left_10'
                      onClick={this._hideReportForm.bind(this, all_questions)}
                    >
                      {' '}
                      {language.LC().CANCEL}
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className='card-block'>
                <div className='row'>
                  <div className='col-sm-12 report-Success-card'>
                    <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                    <label className='form-control-label' htmlFor='textarea-input'>
                      <strong> {language.LC().REPORT_SEND_SUCCESS_MESSAGE}</strong>
                    </label>
                    <button
                      type='button'
                      className='btn btn-primary active pointer_class  min-vw-120'
                      onClick={this.onClose}
                    >
                      {' '}
                      {language.LC().CLOSE}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className='row'>
          </div>
        </div>
      );
    } else {
      /*data = <div className="col-sm-12 col-md-12">
          <div className="no_data_bar card">No Records Found</div></div>;*/
    }

    return (
      <div>
        <div className='animated fadeIn'>
          {/* <div className="row">
            <div className="col-sm-8 margin_bottom_20"> */}
          <div className='margin_bottom_10 d-flex justify-content-between'>
            <div>
              <h1 className='section_head'>{language.LC().QUESTION_BANK}</h1>
            </div>
            {/* </div>

            <div className="col-sm-4 margin_bottom_20 text-sm-right"> */}
            <div>
              <button
                type='button'
                className='btn btn-primary pointer_class'
                onClick={this._getQuestions}
              >
                {language.LC().CHANGE_QUESTIONS}
              </button>
              <button
                type='button'
                className='btn btn-primary pointer_class'
                onClick={this._getReadings}
              >
                {language.LC().CHANGE_CHAPTER}
              </button>
              {/* </div> */}
            </div>
          </div>
          <div className='row'>{data}</div>
        </div>
        {/* {console.log(
          'this.state.display_loader------------',
          this.state.display_loader
        )} */}
        {this.state.display_loader === 'show_block' ? <Loader /> : null}
        {/* <div className={'loader_box ' + this.state.display_loader}>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div> */}
      </div>
    );
  }
}
class TooltipItem extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false,
    };
  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  }

  render() {
    return (
      <span>
        <img
          src={App_data.frontend_url + '/img/dashboard/info_icon.svg'}
          id={'Tooltip-' + this.props.id}
          width='18'
          alt=''
          style={{ marginLeft: '4px' }}
        />
        {/*<i className="fa fa-info-circle"  id={'Tooltip-' + this.props.id} ></i>*/}

        <Tooltip
          placement={this.props.place_tip}
          isOpen={this.state.tooltipOpen}
          target={'Tooltip-' + this.props.id}
          toggle={this.toggle}
        >
          <p className='tooltip_text'>{this.props.content}</p>
        </Tooltip>
      </span>
    );
  }
}
export default GMATBeginchapters;



// WEBPACK FOOTER //
// ./src/views/GMAT/QuestionBank/Beginchapters.js